// src/components/Footer.js
import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="site-footer">
      <Container>
        <div className="site-footer__inner">
          <p className="site-footer__copy">
            &copy; {new Date().getFullYear()} SDG Platform — developed with support from the UN Kosovo Team
          </p>
          <nav className="site-footer__nav" aria-label="Footer">
            <Link to="/contact" className="site-footer__link">
              Contact
            </Link>
          </nav>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
